import React from 'react'
import getCurrentSelectedFilters from '../../../context/search/helpers/getCurrentSelectedFilters'
import useSearch from '../../../context/search/useSearch'


const SearchFilterCount: React.FC = () => {
  const { searchFilters } = useSearch()
  if (!searchFilters) {
    return null
  }
  const selectedFilters = getCurrentSelectedFilters(searchFilters)
  if (!selectedFilters || !selectedFilters.length) {
    return null
  }
  return <>({ selectedFilters.length })</>
}

export default SearchFilterCount
